import React from "react";
import { motion } from "framer-motion";
import { palette } from "../palette";
import { GrainDefs, GrainOverlay } from "./Grain";
import { useReducedMotion } from "../motion";

const ID = "smallgroup";
const W = 600;
const H = 380;
const COLS = 10;
const ROWS = 5;
const c = palette.ill;

// Fifty figures, drawn one per person. The count is the whole point of the
// section, so the illustration is literally countable rather than decorative.
const SHIRTS = [c.plum, c.leaf, c.river, c.clay, c.sun, c.leafDeep, c.skyDeep];

export const SmallGroup = ({ className }) => {
  const reduced = useReducedMotion();

  const people = [];
  const startX = 66;
  const startY = 104;
  const gapX = 52;
  const gapY = 54;

  for (let r = 0; r < ROWS; r += 1) {
    for (let col = 0; col < COLS; col += 1) {
      const i = r * COLS + col;
      people.push({
        i,
        x: startX + col * gapX,
        y: startY + r * gapY,
        shirt: SHIRTS[i % SHIRTS.length],
        skin: c.skin[i % c.skin.length],
      });
    }
  }

  return (
    <motion.svg
      className={className}
      viewBox={`0 0 ${W} ${H}`}
      width="100%"
      role="img"
      aria-label="Fifty figures arranged in a grid of ten by five, representing the fifty people taken on at a time"
      style={{ display: "block", maxWidth: "100%", height: "auto" }}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: reduced ? 0 : 0.012 } },
      }}
    >
      <defs>
        <GrainDefs id={ID} />
        <clipPath id={`${ID}-panel`}>
          <rect width={W} height={H} rx="28" />
        </clipPath>
      </defs>

      <g clipPath={`url(#${ID}-panel)`}>
        <rect width={W} height={H} fill={c.sand} />

        <text
          x={startX - 4}
          y="58"
          fill={palette.text}
          fontSize="40"
          fontWeight="700"
          fontFamily="'Be Vietnam Pro', system-ui, sans-serif"
          letterSpacing="-1"
        >
          50
        </text>
        <text
          x={startX + 52}
          y="58"
          fill={palette.textMuted}
          fontSize="17"
          fontFamily="'Be Vietnam Pro', system-ui, sans-serif"
        >
          people. That's the whole intake.
        </text>

        {people.map((p) => (
          <motion.g
            key={p.i}
            variants={{
              hidden: { opacity: 0, y: 6 },
              show: { opacity: 1, y: 0, transition: { duration: 0.35 } },
            }}
          >
            {/* Shoulders */}
            <path
              d={`M${p.x - 13} ${p.y + 20} Q${p.x - 13} ${p.y + 6} ${p.x} ${p.y + 6} Q${p.x + 13} ${p.y + 6} ${p.x + 13} ${p.y + 20} Z`}
              fill={p.shirt}
            />
            {/* Head */}
            <circle cx={p.x} cy={p.y - 5} r="9" fill={p.skin} />
          </motion.g>
        ))}

        <GrainOverlay id={ID} width={W} height={H} rx={28} opacity={0.24} />
      </g>
    </motion.svg>
  );
};

export default SmallGroup;
